var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#333"},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M3.112 1.522c0 .84-.693 1.521-1.55 1.521-.856 0-1.55-.68-1.55-1.521C.012.682.706 0 1.563 0c.857 0 1.55.682 1.55 1.522zm.013 2.739H0V14h3.125V4.26zm4.989 0H5.009V14h3.105V8.888c0-2.843 3.768-3.076 3.768 0V14H15V7.833c0-4.796-5.576-4.622-6.886-2.26V4.26z","transform":"translate(-2145 -1016) translate(2144 932) translate(1 84)"}))))));
}

Linkedin.defaultProps = {"width":"15","height":"14","viewBox":"0 0 15 14"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
